module.exports = __webpack_public_path__ + "media/images/common/sns/twitter-230c7314b086e83b87b5555bb4bdafc4.png";